
// SCRIPTS

//import { SecureHomePage } from './home/home.page'; export { SecureHomePage };
import { SitesPage } from './ctms/sites/sites.page'; export { SitesPage };
import { ActionItemsPage } from './ctms/action-items/action-items.page'; export { ActionItemsPage };
import { ContactsPage } from './ctms/contacts/contacts.page'; export { ContactsPage };
import { CommunicationsPage } from './ctms/communications/communications.page'; export { CommunicationsPage };
import { DeliverablesPage } from './ctms/deliverables/deliverables.page'; export { DeliverablesPage };
import { MilestonesPage } from './ctms/milestones/milestones.page'; export { MilestonesPage };
import { StudiesPage } from './ctms/studies/studies.page'; export { StudiesPage };
import { CTMSStudyDetailsPage } from './ctms/studies/scripts/study-details.page'; export { CTMSStudyDetailsPage };
import { SettingsPage } from './ctms/settings/settings.page'; export { SettingsPage };
import { EnrollmentPage } from './reporting/enrollment/scripts/enrollment.page'; export { EnrollmentPage };
import { LdnPage } from './public-comment/ldn.page'; export { LdnPage };
import { TrialCabPage } from './collaboration/trial-cab.page'; export { TrialCabPage };
import { UserManagementPage } from './user-management/scripts/user-management.page'; export { UserManagementPage };
import { ChecklistPage } from './site-checklist/site-checklist.page'; export { ChecklistPage };
import { ExecutiveSummaryPage } from './reporting/executive-summary/scripts/executive-summary.page'; export { ExecutiveSummaryPage };
import { LMSTrainingsPage } from './lms/settings/scripts/trainings.page'; export { LMSTrainingsPage };
import { LMSHomePage } from './lms/home/scripts/home.page'; export { LMSHomePage };
import { LMSSettingsPage } from './lms/settings/scripts/settings.page'; export { LMSSettingsPage };
import { LMSSiteStudyDetailsPage } from './lms/settings/scripts/site-study-details.page'; export { LMSSiteStudyDetailsPage };
import { LMSSiteStudyTrainingDetailsPage } from './lms/settings/scripts/site-study-training-details.page'; export { LMSSiteStudyTrainingDetailsPage };
import { LMSSiteStudyUserDetailsPage } from './lms/settings/scripts/site-study-user-details.page'; export { LMSSiteStudyUserDetailsPage };

// STYLES
import './home/home.scss';
import './site-interests/site-interest.scss';
import './public-comment/ldn.scss';
import './user-management/user-management.scss';
import './public-comment/sgb.scss';
import './reporting/enrollment/Enrollment.scss';
import './public-comment/glp.scss';
import './collaboration/trial-cab.scss';
import './reporting/executive-summary/executive-summary.scss';
import './site-checklist/site-checklist.scss';
import './lms/lms.scss';